module.exports = __webpack_public_path__ + "static/media/Yashweb3.fb5d9a79.png";